import { lazy } from "react";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { POLICY_CHANGE_LIST } from "../Business.constants";

const PolicyChangeList = Loadable(
  lazy(() =>
    import("./PolicyChangeList").then(({ PolicyChangeList }) => ({
      default: PolicyChangeList,
    }))
  )
);
export const PolicyChangeRoutes = [
  {
    path: `${POLICY_CHANGE_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <PolicyChangeList />
      </AuthorizedRoute>
    ),
  },
];
